import logoOnDark from './ymtech-logo-on-dark.png';
import logoOnLight from './ymtech-logo-on-light.png';

import type { Brand } from '../types';

/**
 * YMtech — the reveal page of their instance, view.ymtech.com.
 *
 * Same artwork as the app's brand (SharePass-Frontend-V2/src/brands/ymtech): YMtech publishes one
 * logo, in their blue and a warm black, and `on-dark` is that file with only the black turned
 * white. Keep the two repos' copies in step; if YMtech ever publishes a reversed logo, replace
 * both files rather than re-deriving either.
 */
export const brand: Brand = {
    name: import.meta.env.VITE_BRAND_NAME || 'YMtech',
    logo: {
        onLight: logoOnLight,
        onDark: logoOnDark,
        barHeight: 44,
    },
    isDedicatedInstance: true,
    homeUrl: 'https://ymtech.com',
};
